import React, { Component } from 'react';
import {BrowserRouter as Router, Route,Switch} from 'react-router-dom';
import home from './container/home';
import about from './container/About';
import contact from './container/contact';
import notfound from './container/404';
import historique from './container/historique'
import loyalty from './container/loyalty'
import detail from './container/blog-page'
import blogdetail from './container/blog-detail-page'

import ModalConnection from './container/ModalConnectionSubscribe';
import {doSignOut} from './authDB';

import  ProfileRestaurant from './container/food-menu';

class App extends Component {
  constructor(){
    super();
    this.state = {id : 1};
   
  }

  show_connection(){
    this.refs.ModalConnection.handleShow();
console.log(this.refs)
}
Deconx(){
  localStorage.removeItem('user')
  doSignOut().then(()=>{
    window.parent.location = window.parent.location.href;

  })
}
  render() {
   console.log(this.props)
    return (
        <Router>
          <div>
       
          <Switch>

          <Route exact path='/' component={home}/>
          <Route  path='/about/' component={about}/>
          <Route path='/detail/:blog' component={blogdetail} /> 
          <Route path='/contact/' component={contact}/>
          <Route path='/historique/' component={historique}/>
        <Route path='/order/' component={ProfileRestaurant} /> 
        <Route path='/loyalty/' component={loyalty} /> 
        <Route path='/Blog/' component={detail} /> 
       

        
          
          <Route path="*" component={notfound}/>
          </Switch>
          <footer className="footer section-padding">
    <div className="container">
        <div className="row">
            <div className="col-md-4 col-sm-12">
                <div className="footer-widget">
                    <div className="row">
                        <div className="col-xs-11 col-sm-10 col-md-9">
                            <h3 className="main-title footer-title text-left">
                                <span>
                                Contactez Nous

                                </span>
                            </h3>
                        </div>
                    </div>

                    <div className="content">
                        <p>
                            <i className="fa fa-map-marker"> </i>
                            <span>ADRESSE :</span> Yasser Arafat Avenue, complexe Rosaria Sahloul
                        </p>
                        <p>
                            <i className="fa fa-phone"> </i>
                            <span>APPELEZ-NOUS :</span>+216 50 406 487
                        </p>
                      
                        <h5>SUIVEZ-NOUS SUR  :</h5>
                        <ul className="mini-social">
                            <li>
                                <a href="https://www.facebook.com/bistro73Sousse/">
                                    <i className="fa fa-facebook"></i>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-google-plus"></i>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-instagram"></i>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-twitter"></i>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-linkedin"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-md-4 col-sm-6">
            <div className="footer-widget">
                    <div className="row">
                        <div className="col-xs-11 col-sm-10 col-md-9">
                            <h3  className="main-title footer-title text-left">
                                <span>
                                    Gallerie photos
                                </span>
                            </h3>
                        </div>
                    </div>
                    
                    <div className="content">
                        <ul className="gallery clearfix">
                            <li>
                                <div>
                                <a href="/images/gal-big12.png" className="magni-link">
                                <img src="/images/gal12.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big11.png" className="magni-link">
                                <img src="/images/gal11.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big10.png" className="magni-link">
                                <img src="/images/gal10.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big9.png" className="magni-link">
                                <img src="/images/gal9.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big8.png" className="magni-link">
                                <img src="/images/gal8.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big7.png" className="magni-link">
                                <img src="/images/gal7.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>


            </div>
            <div className="col-md-4 col-sm-6">
                <div className="footer-widget">
                    <div className="row">
                        <div className="col-xs-11 col-sm-10 col-md-9">
                            <h3 style={{color:"#ffffff"}} className="main-title footer-title text-left">
                                <span>
                                    Gallery Pics
                                </span>
                            </h3>
                        </div>
                    </div>
                    
                    <div className="content">
                        <ul className="gallery clearfix">
                            <li>
                                <div>
                                <a href="/images/gal-big6.png" className="magni-link">
                                <img src="/images/gal6.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big5.png" className="magni-link">     
                                <img src="/images/gal5.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big4.png" className="magni-link">
                                <img src="/images/gal4.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big3.png" className="magni-link">
                                <img src="/images/gal3.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big2.png" className="magni-link">
                                <img src="/images/gal2.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                <a href="/images/gal-big.png" className="magni-link">
                                        <img src="/images/gal.png" alt="gallery pic"/>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalConnection ref="ModalConnection"/>
</footer>
<div className="copyright">

    <p>
    © Copyright <a href="https://www.iobird.com/" target="iobird">  Iobird Tunisie 2018 </a>. Tous droits réservés.
        
    </p>
</div>
        </div>
        
      </Router>
      
   
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/Approuter.js